import { Link, NavLink } from 'react-router-dom'
import { HaebomLogo } from '@/shared/ui/HaebomLogo'
import { buttonStyles } from '@/shared/ui/Button'
import { CityIcon } from '@/shared/ui/icons/CityIcon'
import { MessageIcon } from '@/shared/ui/icons/MessageIcon'
import { MAIN_NAV } from '@/shared/constants/navigation'

export function WideHeader() {
  return (
    <header className="wide-header">
      <div className="wide-header__inner">
        <Link className="wide-header__logo" to="/" aria-label="해봄 홈">
          <span className="wide-header__logo-tablet">
            <HaebomLogo variant="i" height={30} />
          </span>
          <span className="wide-header__logo-pc">
            <HaebomLogo variant="i" symbol="brand01" height={30} />
          </span>
        </Link>
        <nav className="wide-header__menu" aria-label="주요 메뉴">
          {MAIN_NAV.map((item, i) => (
            <span className="wide-header__item" key={item.to}>
              {i > 0 && <span className="ui-divider-v" aria-hidden="true" />}
              <NavLink className="wide-header__link" to={item.to} end={item.end}>
                {item.label}
              </NavLink>
            </span>
          ))}
        </nav>

        <div className="wide-header__cta">
          <Link className={buttonStyles('md', 'primary', 'min-w-[180px]')} to="/problems/new">
            <MessageIcon size={20} />
            우리 동네 문제 등록하기
          </Link>
          <Link className={buttonStyles('md', 'assistive', 'min-w-[134px]')} to="/orgs/new">
            <CityIcon size={20} />
            기업 등록하기
          </Link>
        </div>
      </div>
    </header>
  )
}
